// extracted by mini-css-extract-plugin
export default {"container":"VEaca","label":"rkqbv"};